import React, { useState, useCallback, useEffect, useRef } from "react";
import "./AllUsers.css";
import { Container, Row, Col, Form } from "react-bootstrap";
import { BiFilter } from "react-icons/bi";
import { GrPowerReset } from "react-icons/gr";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllUsers } from "../../Actions/adminActions";
import PaginationComponent from "../../Component/Pagination/PaginationControls";
import apiCall from "./../../API/API";
import moment from "moment";
import debounce from "lodash.debounce";
import ExportExcel from "../../Component/ExportExcel/ExportExcel";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_PATH_USER_LOGIN } from "./../../API/API";
import { fetchApiRoutes } from "../../Actions/adminActions";
import routesData from "../../Sidebar/Routes.json";
const dashIfEmpty = (val) => {
  if (val === null || val === undefined || val === "") return "-";
  if (typeof val === "string" && !val.trim()) return "-";
  return val;
};

const AllUsers = () => {
  console.log("2222222222222222222222222222222222222222222222222");
  const navigate = useNavigate();
  const location = useLocation();
  const defaultSearchState = {
    name: "",
    username: "",
    uid: "",
    startDateJoining: "",
    endDateJoining: "",
    wallet_address: "",
    status: "",
    userRole: "",
    directIncomeRankId: "",
  };
  const restoredState = location.state?.restoreState;
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state.admin);
  const [filter, setFilter] = useState("none");
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(restoredState?.currentPage || 1);
  const [totalPages, setTotalPages] = useState(1);
  const [limitFilter, setLimitFilter] = useState(restoredState?.limitFilter || 20);
  const [showModal, setShowModal] = useState(false);
  const [showTreeModal, setShowTreeModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUid, setSelectedUid] = useState(null);
  const [blockStatus, setBlockStatus] = useState(0);
  const [treeStatus, setTreeStatus] = useState(0);
  const [activityData, setActivityData] = useState([]);
  const [showEnableTreeModal, setShowEnableTreeModal] = useState(false);
  const [showDisableTreeModal, setShowDisableTreeModal] = useState(false);
  const [isAutoCreateVersionLoading, setIsAutoCreateVersionLoading] =
    useState(false);
  const [search, setsearch] = useState({
    ...defaultSearchState,
    ...(restoredState?.search || {}),
  });
  const [rankFilterOptions, setRankFilterOptions] = useState([]);
  const [dateFilter, setDateFilter] = useState(restoredState?.dateFilter || "default");
  const fetchUsers = useCallback(
    debounce((params) => {
      dispatch(fetchAllUsers(params));
    }, 500),
    [dispatch],
  );

  const toggleFilter = () => {
    if (filter === "none") {
      setFilter("flex");
    } else {
      setFilter("none");
    }
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const normalizeFilterValue = (name, value) => {
    if (name === "status" && value !== "") {
      return Number(value);
    }
    return value;
  };

  const getFilteredSearchParams = (searchState) =>
    Object.fromEntries(
      Object.entries(searchState).filter(
        ([_, value]) => value !== "" && value !== null && value !== undefined,
      ),
    );

  const handleChange = (e) => {
    const { name, value } = e.target;
    const normalizedValue = normalizeFilterValue(name, value);
    setsearch((prev) => {
      const updatedSearch = { ...prev, [name]: normalizedValue };
      Object.keys(updatedSearch).forEach((key) => {
        if (updatedSearch[key] === "" || updatedSearch[key] === null) {
          delete updatedSearch[key];
        }
      });
      return updatedSearch;
    });

    fetchUsers({
      page: currentPage,
      limit: limitFilter,
      ...getFilteredSearchParams({ ...search, [name]: normalizedValue }),
    });
  };

  const handleLimitChange = (e) => {
    setLimitFilter(e.target.value);
  };

  const handleDateFilterChange = (e) => {
    const value = e.target.value;
    setDateFilter(value);
    const today = moment().endOf("day");
    let startDateJoining = "";
    let endDateJoining = "";
    switch (value) {
      case "today":
        startDateJoining = today.startOf("day").format("YYYY-MM-DD");
        endDateJoining = today.format("YYYY-MM-DD");
        break;
      case "yesterday":
        startDateJoining = today
          .subtract(1, "days")
          .startOf("day")
          .format("YYYY-MM-DD");
        endDateJoining = today.endOf("day").format("YYYY-MM-DD");
        break;
      case "this_week":
        startDateJoining = today.startOf("week").format("YYYY-MM-DD");
        endDateJoining = today.endOf("week").format("YYYY-MM-DD");
        break;
      case "this_month":
        startDateJoining = today.startOf("month").format("YYYY-MM-DD");
        endDateJoining = today.endOf("month").format("YYYY-MM-DD");
        break;
      default:
        startDateJoining = "";
        endDateJoining = "";
        break;
    }
    setsearch((prev) => ({
      ...prev,
      startDateJoining,
      endDateJoining,
    }));
  };
  const AddFilter = () => {
    const queryParams = {
      page: currentPage,
      limit: limitFilter,
      ...getFilteredSearchParams(search),
    };
    dispatch(fetchAllUsers(queryParams));
  };

  const loginUser = async (username) => {
    // console.log("userId", username);
    try {
      const { data, error } = await apiCall(
        "POST",
        "/login-user",
        { username },
        true,
      );
      if (data) {
        // window.open(
        //   `https://useraumron.mlmreadymade.com/?token=${data.token}`,
        //   "_blank"
        // );

        // window.open(
        //   `http://192.168.1.99:3002/dashboard/?token=${data.token}`,
        //   "_blank"
        // );
        window.open(
          `${API_BASE_PATH_USER_LOGIN}/?token=${data.token}`,
          "_blank",
        );
        // window.open(
        //   `https://user.aumron.com/dashboard/?token=${data.token}`,
        //   "_blank"
        // );
        // window.open(
        //   `https://testuser.aumron.com/dashboard/?token=${data.token}`,
        //   "_blank"
        // );
      }
    } catch (error) {
      console.error("Error logging in user:", error);
    }
  };

  const resetFilter = () => {
    const queryParams = {
      page: "1",
      limit: 20,
    };
    dispatch(fetchAllUsers(queryParams));
    setsearch({
      name: "",
      username: "",
      wallet_address: "",
      startDateJoining: "",
      endDateJoining: "",
      uid: "",
      status: "",
      userRole: "",
      directIncomeRankId: "",
    });
    setLimitFilter(20);
    setDateFilter("default");
    setCurrentPage(1);
  };

  const handleAutoCreateVersion = async () => {
    if (isAutoCreateVersionLoading) return;
    setIsAutoCreateVersionLoading(true);
    try {
      await apiCall("POST", "/auto_create_version", {}, true);
    } finally {
      setIsAutoCreateVersionLoading(false);
    }
  };

  useEffect(() => {
    const queryParams = {
      page: currentPage,
      limit: limitFilter,
      ...getFilteredSearchParams(search),
    };
    fetchUsers(queryParams);
  }, [currentPage, limitFilter, search, fetchUsers]);

  const handleModalClose = () => setShowModal(false);
  const handleModalShow = (username, status) => {
    setSelectedUser(username);
    setBlockStatus(status);
    setShowModal(true);
  };

  // const handleTreeModalClose = () => setShowTreeModal(false);
  // const handleTreeModalShow = (uid, status) => {
  //   setSelectedUid(uid);
  //   setTreeStatus(status);
  //   setShowTreeModal(true);
  // };

  const handleTreeModalShow = (activity, activityAction) => {
    setSelectedActivity(activity);
    setActivityLength(activity?.disabled_activities.length);
    console.log(activity?.disabled_activities.length, "activity");
    if (activityAction === "enable") {
      setShowEnableTreeModal(true);
    } else {
      setShowDisableTreeModal(true);
    }
  };

  const handleTreeModalClose = (activityAction) => {
    if (activityAction === "enable") {
      setShowEnableTreeModal(false);
    } else {
      setShowDisableTreeModal(false);
    }
    setSelectedActivity(null);
    setSelectActivityId([]);
    setActivityLength(0);
  };

  const handleActivityTree = async (uid, action) => {
    try {
      console.log("uid:  ", uid);
      console.log("action:  ", action);
      console.log("Selected Act Ids", selectActivityId);
      const { data, error } = await apiCall(
        "post",
        "/block_unblock_tree_activity",
        {
          uid: uid,
          act_ids: selectActivityId,
          action: action,
        },
      );

      if (data) {
        const queryParams = {
          page: currentPage,
          limit: 20,
        };
        dispatch(fetchAllUsers(queryParams));
        setSelectActivityId([]);
        setActivityLength(0);

        setShowEnableTreeModal(false);
        setShowDisableTreeModal(false);

        if (Array.isArray(data.message)) {
          data.message.forEach((msg) => toast.success(msg));
        } else {
          toast.success(data.message);
        }
      } else if (error) {
        if (Array.isArray(error.message)) {
          error.message.forEach((msg) => toast.error(msg));
        } else {
          toast.error(error.message);
        }
      }
    } catch (error) {
      if (Array.isArray(error.message)) {
        error.message.forEach((msg) => toast.error(msg));
      } else {
        toast.error(error.message);
      }
    }
  };

  const BlockUsers = async (username, block_Status) => {
    try {
      const { data, error } = await apiCall("POST", "/user_block_unblock", {
        username,
        block_Status,
      });

      if (error) {
        toast.error(error.message || "An error occurred");
      } else {
        toast.success(
          data.message ||
            (blockStatus === 1 ? "User is blocked!" : "User is unblocked!"),
        );
        const queryParams = {
          page: currentPage,
          limit: limitFilter,
          ...getFilteredSearchParams(search),
        };

        try {
          dispatch(fetchAllUsers(queryParams));
        } catch (error) {
          console.log("2222222222222222222", error);
        }
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const BlockUserTree = async (uid, action) => {
    const disenable = action == 0 ? "disable" : "enable";
    console.log("disenable", disenable);
    try {
      const { data, error } = await apiCall("POST", "/block_tree_widthrawal", {
        uid: uid,
        action: disenable,
      });

      if (error) {
        toast.error(error.message || "An error occurred");
      } else {
        toast.success(
          data.message ||
            (blockStatus === 1 ? "User is blocked!" : "User is unblocked!"),
        );
        const queryParams = {
          page: currentPage,
          limit: limitFilter,
          ...getFilteredSearchParams(search),
        };

        try {
          dispatch(fetchAllUsers(queryParams));
        } catch (error) {
          console.log("2222222222222222222", error);
        }
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    setTotalRecords(userData?.totalRecords);
    if (userData?.totalPages) {
      setTotalPages(userData.totalPages);
    }
  }, [userData]);

  const [totalRecord, setTotalRecords] = useState(0);
  const [exportData, setExportData] = useState([]);

  const handleExportExcel = async () => {
    try {
      // const queryParams = {
      //   source: "generate_fund",
      //   limit: totalRecord
      // }
      const { data } = await apiCall(
        "GET",
        `/get-all-users?limit=${totalRecord}`,
        null,
        false,
      );

      setExportData(data?.data);

      // console.log("export excel response", data?.data);
      // toast.success("Excel file has been downloaded!");
    } catch (error) {
      // toast.error("Failed to export data");
    }
  };
  useEffect(() => {
    handleExportExcel();
  }, []);

  const fetchActivities = async () => {
    try {
      const { data, error } = await apiCall("GET", "/get-all-activity");
      if (data) {
        console.log("2222222222222", data?.activities);
        const activities = data?.activities;
        console.log(activities, "activities");
        setActivityData(activities);
      } else if (error) {
        // toast.error(error.message || "An error occurred");
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    fetchActivities();
  }, []);

  useEffect(() => {
    const loadRankFilterOptions = async () => {
      try {
        const { data, error } = await apiCall(
          "POST",
          "/get-plan-id",
          { planId: 1 },
        );
        if (error) return;
        const planData = data?.data || data;
        const rewards = planData?.reward?.rewards || [];
        setRankFilterOptions(rewards);
      } catch (e) {
        console.error("Failed to load rank options for filter", e);
      }
    };
    loadRankFilterOptions();
  }, []);

  const getDisabledActivityNames = (disabledActivities, allActivities) => {
    return disabledActivities?.map((actId) => {
      const activity = allActivities.find((act) => act.act_id === actId);
      return activity ? activity.name : null;
    });
  };
  const [showEnableModal, setShowEnableModal] = useState(false);
  const [showDisableModal, setShowDisableModal] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [activityLength, setActivityLength] = useState();
  const [selectActivityId, setSelectActivityId] = useState([]);

  const handleButtonClick = (activity, activityAction) => {
    setSelectedActivity(activity);
    setActivityLength(activity?.disabled_activities.length);
    console.log(activity?.disabled_activities.length, "activity");
    if (activityAction === "enable") {
      setShowEnableModal(true);
    } else {
      setShowDisableModal(true);
    }
  };

  const handleDisableModalClose = (activityAction) => {
    if (activityAction === "enable") {
      setShowEnableModal(false);
    } else {
      setShowDisableModal(false);
    }
    setSelectedActivity(null);
    setSelectActivityId([]);
    setActivityLength(0);
  };

  // const handleModalSubmit = async () => {
  //   if (selectedActivity && action) {
  //     await handleActivity(
  //       selectedActivity.username,
  //       selectedActivity.activity_id,
  //       action
  //     );
  //     handleModalClose();
  //   } else {
  //     toast.error("Please select an action.");
  //   }
  // };

  const handleActivity = async (username, action) => {
    try {
      console.log("body", username, action, selectActivityId);
      const { data, error } = await apiCall(
        "post",
        "/disable-enable-activity",
        {
          username: username,
          act_ids: selectActivityId,
          action: action,
        },
      );

      if (data) {
        const queryParams = {
          page: currentPage,
          limit: 20,
        };
        dispatch(fetchAllUsers(queryParams));
        setSelectActivityId([]);
        setActivityLength(0);

        setShowEnableModal(false);
        setShowDisableModal(false);
        if (Array.isArray(data.message)) {
          data.message.forEach((msg) => toast.success(msg));
        } else {
          toast.success(data.message);
        }
      } else if (error) {
        if (Array.isArray(error.message)) {
          error.message.forEach((msg) => toast.error(msg));
        } else {
          toast.error(error.message);
        }
      }
    } catch (error) {
      if (Array.isArray(error.message)) {
        error.message.forEach((msg) => toast.error(msg));
      } else {
        toast.error(error.message);
      }
    }
  };

  const { routes } = useSelector((state) => state.admin);
  const [permissions, setPermissions] = useState({});

  var x = 0;
  useEffect(() => {
    if (x === 0) dispatch(fetchApiRoutes());
    x++;
  }, [dispatch]);

  useEffect(() => {
    if (routes?.routes?.length > 0) {
      const updatedPermissions = {};
      // console.log("local routes", routesData);
      routesData.forEach((localRoute) => {
        // console.log("api routes", routes);
        const match = routes?.routes.find(
          (apiRoute) =>
            apiRoute.path === localRoute.path &&
            apiRoute.showInMenu === localRoute.showInMenu,
        );

        if (match) {
          // console.log(`Matched Route:`, localRoute.path);
          updatedPermissions[localRoute.stateKey] = true; // Enable section
        }
      });
      console.log("updatedPermissions", updatedPermissions);
      setPermissions(updatedPermissions);
      // console.log(permissions);
    }
  }, [routes]);

  /* ——— Change sponsor ——— */
  const [sponsorShow, setSponsorShow] = useState(false);
  const [openSponsorSuccessDialog, setOpenSponsorSuccessDialog] =
    useState(false);
  const [sponsorChangeUid, setSponsorChangeUid] = useState(null);
  const [sponsorUsername, setSponsorUsername] = useState("");
  const [sponsorRowUsername, setSponsorRowUsername] = useState("");
  const [newSponsor, setNewSponsor] = useState("");
  const [sponsorPosition, setSponsorPosition] = useState("left");
  const [existUserName, setExistUserName] = useState(". . .");
  const [sponsorCheckLoading, setSponsorCheckLoading] = useState(false);
  const sponsorDebounceRef = useRef(null);

  const handleSponsorShow = (uid, currentSponsorUsername, username) => {
    setSponsorChangeUid(uid);
    setSponsorUsername(currentSponsorUsername || "");
    setSponsorRowUsername(username);
    setNewSponsor("");
    setSponsorPosition("left");
    setExistUserName(". . .");
    setSponsorShow(true);
  };

  const isUserExist = useCallback(async () => {
    setSponsorCheckLoading(true);
    if (!newSponsor?.trim()) {
      setExistUserName(". . .");
      setSponsorCheckLoading(false);
      return;
    }
    try {
      const { data, error } = await apiCall("post", "/check_username", {
        username: newSponsor.trim(),
      });
      if (data) {
        setExistUserName(data.name ?? "—");
      } else if (error) {
        setExistUserName("User not exists");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "An error occurred");
    }
    setSponsorCheckLoading(false);
  }, [newSponsor]);

  useEffect(() => {
    if (!sponsorShow) return;
    if (sponsorDebounceRef.current) {
      clearTimeout(sponsorDebounceRef.current);
    }
    sponsorDebounceRef.current = setTimeout(() => {
      isUserExist();
    }, 1000);
    return () => {
      if (sponsorDebounceRef.current) {
        clearTimeout(sponsorDebounceRef.current);
      }
    };
  }, [newSponsor, sponsorShow, isUserExist]);

  const handleSponsorChange = async () => {
    if (!newSponsor?.trim()) {
      toast.error("Enter a sponsor username");
      return;
    }
    if (existUserName === "User not exists" || existUserName === ". . .") {
      toast.error("Please enter a valid sponsor username");
      return;
    }
    if (sponsorPosition !== "left" && sponsorPosition !== "right") {
      toast.error("Select position: left or right");
      return;
    }
    try {
      const body = {
        sponsor_username: newSponsor.trim(),
        position: sponsorPosition,
      };
      const { data, error } = await apiCall(
        "POST",
        `/change_sponsor?uid=${sponsorChangeUid}`,
        body,
        true,
      );
      if (data) {
        toast.success(data?.message || "Sponsor updated successfully");
        setSponsorShow(false);
        setOpenSponsorSuccessDialog(true);
        const queryParams = {
          page: currentPage,
          limit: limitFilter,
          ...getFilteredSearchParams(search),
        };
        dispatch(fetchAllUsers(queryParams));
      } else if (error) {
        toast.error(error?.message || "Failed to change sponsor");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.message || "Failed");
    }
  };

  const handleSponsorDialogClose = () => {
    setOpenSponsorSuccessDialog(false);
    setSponsorShow(false);
    setNewSponsor("");
    setSponsorPosition("left");
    setExistUserName(". . .");
  };

  const handleSponsorModalClose = () => {
    setSponsorShow(false);
    setNewSponsor("");
    setSponsorPosition("left");
    setExistUserName(". . .");
  };

  return (
    <React.Fragment>
      <Container className="users-page">
        <div className="users-head">
          <div>
            <p>Home / All Users</p>
            <h1>All Users</h1>
          </div>
          <div>
            {/* <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={handleAutoCreateVersion}
              disabled={isAutoCreateVersionLoading}
            >
              Version Control
            </button> */}
            <ExportExcel
              data={exportData}
              columns={[
                "username",
                "name",
                "uid",
                "wallet_address",
                "joining_date",
                "Activation_date",
                "self_investment",
                "main_wallet",
                "fund_wallet",
                "highest_direct_income_rank_name",
                "sponsor_username",
                "sponsor_name",
                "disabled_activities",
              ]}
              fileName="Users.xlsx"
            />
          </div>
        </div>
        <section className="users-panel">
        <Row id="filterRow" className="g-0">
          <span
            id="filterLogo1"
            className={filter === "flex" ? "is-open" : ""}
            onClick={() => toggleFilter()}
          >
            <i>
              <BiFilter />
            </i>
            Filter
          </span>
          <Row className="p-0 m-0" style={{ display: filter }}>
            <Col lg="2" md="4">
              <div>
                <input
                  type="text"
                  placeholder="Search User By Username"
                  name="username"
                  value={search.username}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="text"
                  placeholder="Search User By Uid"
                  name="uid"
                  value={search.uid}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="text"
                  placeholder="Search User By Wallet Address"
                  name="wallet_address"
                  value={search.wallet_address}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="date"
                  placeholder="from date"
                  name="startDateJoining"
                  value={search.startDateJoining}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="date"
                  placeholder="to date"
                  name="endDateJoining"
                  value={search.endDateJoining}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name="dateFilter"
                  value={dateFilter}
                  onChange={handleDateFilterChange}
                >
                  <option value="default">Default</option>
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="this_week">This Week</option>
                  <option value="this_month">This Month</option>
                </select>
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name="limit"
                  value={limitFilter}
                  onChange={handleLimitChange}
                >
                  <option value="">--All--</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                </select>
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name="status"
                  value={search.status ?? ""}
                  onChange={handleChange}
                >
                  <option value="">--Status--</option>
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>
            </Col>
            {permissions?.setUserPasswordUpdate &&
              permissions?.setUserProfileUpdate && (
                <Col lg="2" md="4">
                  <div>
                    <select
                      name="userRole"
                      value={search.userRole}
                      onChange={handleChange}
                    >
                      <option value="">--Role--</option>
                      <option value="admin">Admin</option>
                      <option value="manager">Manager</option>
                      <option value="user">User</option>
                    </select>
                  </div>
                </Col>
              )}
            <Col lg="2" md="4">
              <div>
                <select
                  name="directIncomeRankId"
                  value={search.directIncomeRankId ?? ""}
                  onChange={handleChange}
                >
                  <option value="">--Designation--</option>
                  {rankFilterOptions.map((r) => (
                    <option key={r.rankId} value={String(r.rankId)}>
                      {r.rank_name}
                    </option>
                  ))}
                </select>
              </div>
            </Col>
            <div className="users-filter-actions">
              <button className="save filter" onClick={AddFilter}>
                Filter{" "}
                <i>
                  <BiFilter />
                </i>
              </button>
              <button className="cancel reset" onClick={resetFilter}>
                Reset{" "}
                <i>
                  <GrPowerReset />
                </i>
              </button>
            </div>
          </Row>
        </Row>
        <Row id="directTableRow">
          <Col md="12" className="p-0">
            <div style={{ width: "100%" }}>
              <table>
                <thead>
                <tr>
                  <th>S No.</th>
                  <th>Username</th>
                  <th>Name</th>
                  {permissions?.setLoginUser && <th>Login</th>}
                  <th>Uid</th>
                  <th>Wallet Address</th>
                  <th>Joining Date</th>
                  <th>Activation Date</th>
                  <th>Self Investment</th>
                  <th>Main Wallet</th> 
                  <th>Fund wallet</th>
                  {/* <th>Fund wallet</th>
                  <th>Gaming wallet</th>
                  <th>Working wallet</th>*/}
                  <th>Designation</th>
                  {/* <th>Rank ID</th> */}
                  <th>Sponsor</th>
                  <th>Sponsor Name</th>
                  {/* {permissions?.setUsers && <th>Change Sponsor</th>} */}
                  <th>Disabled Activities</th>
                  {permissions?.setActionActivities && (
                    <th>Action Activities</th>
                  )}
                  {/* {permissions?.setTreeActivities && <th>Tree Action</th>} */}
                  {permissions?.setUserPasswordUpdate &&
                    permissions?.setUserProfileUpdate && <th>Edit Profile</th>}
                  {permissions?.setBlockUnblockUser && <th>Action</th>}
                  {/* <th>Action</th> */}
                </tr>
                </thead>
                <tbody>
                {userData?.data?.map((x, i) => {
                  return (
                    <tr key={i}>
                      <td>{i + 1 + limitFilter * (currentPage - 1)}</td>
                      <td>
                        <span className="users-name">
                          <span
                            className={`status-dot ${
                              Number(x?.status) === 0 ? "inactive" : "active"
                            }`}
                          />
                          {x?.username}
                        </span>
                      </td>
                      <td>{x?.name}</td>
                      {permissions?.setLoginUser && (
                        <td className="users-login-cell">
                          <button
                            className="block-btn users-login-btn"
                            onClick={() => loginUser(x.username)}
                          >
                            Login
                          </button>
                        </td>
                      )}
                      <td className="users-uid">{x?.uid}</td>
                      <td className="users-wallet">{x?.wallet_address}</td>
                      <td className="users-date">
                        {moment(x?.joining_date).format(
                          "MM-DD-YYYY   &   HH:mm",
                        )}
                      </td>
                      <td className="users-date">
                        {x.Activation_date
                          ? moment(x.Activation_date).format(
                              "MM-DD-YYYY  &  HH:mm",
                            )
                          : " "}
                      </td>
                      <td>{parseFloat(x?.self_investment).toFixed(2)}</td>
                      <td>{parseFloat(x?.main_wallet).toFixed(2)}</td>
                      <td>{parseFloat(x?.fund_wallet).toFixed(2)}</td>
                      {/*<td>{parseFloat(x?.gaming_wallet).toFixed(2)}</td>
                      <td>{parseFloat(x?.working_wallet).toFixed(2)}</td>

                      {Number(x?.status) === 0 ? (
                        <td style={{ color: "red" }}>Inactive</td>
                      ) : (
                        <td style={{ color: "green" }}>Active</td>
                      )}*/}
                      <td>
                        {dashIfEmpty(x?.highest_direct_income_rank_name)}
                      </td>
                      {/* <td>
                        {dashIfEmpty(x?.highest_direct_income_rank_id)}
                      </td> */}
                      <td>{x.sponsor_username}</td>
                      <td>{x.sponsor_name}</td>
                      {/* {permissions?.setUsers && (
                        <td>
                          <button
                            type="button"
                            className="block-btn"
                            onClick={() =>
                              handleSponsorShow(
                                x.uid,
                                x.sponsor_username,
                                x.username,
                              )
                            }
                          >
                            Change Sponsor
                          </button>
                        </td>
                      )} */}

                      <td>
                        {getDisabledActivityNames(
                          x.disabled_activities,
                          activityData,
                        )?.map((name, i) => (
                          <div key={i}>
                            <span>
                              {name
                                ?.split("_") // Split the text by underscore
                                ?.map((word, index) =>
                                  index === 0
                                    ? word.charAt(0).toUpperCase() +
                                      word.slice(1)
                                    : word.charAt(0).toUpperCase() +
                                      word.slice(1),
                                )
                                .join(" ")}
                            </span>
                          </div>
                        ))}
                      </td>
                      {permissions?.setActionActivities && (
                        <td className="text-center">
                          <button
                            className="btn btn-success"
                            style={{
                              marginRight: "10px",
                            }}
                            onClick={() => handleButtonClick(x, "enable")}
                          >
                            Enable
                          </button>
                          <button
                            className="btn btn-danger"
                            onClick={() => handleButtonClick(x, "disable")}
                          >
                            Disable
                          </button>
                        </td>
                      )}
                      {/* Modal for Enabling Action Activities */}
                      <Modal
                        show={showEnableModal}
                        onHide={() => handleDisableModalClose("enable")}
                        centered
                        scrollable
                        backdropClassName="modal-backdrop-light"
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Enable User Activity</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <p>
                            Select activities to <u>ENABLE</u> for user:{" "}
                            <strong>{selectedActivity?.username}</strong>.
                          </p>
                          <hr />
                          <Form>
                            <Form.Group controlId="formEnableActivitySelection">
                              <Form.Label>
                                Currently Disabled Activities:
                              </Form.Label>
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "10px",
                                }}
                              >
                                {activityData
                                  ?.filter((act) =>
                                    selectedActivity?.disabled_activities?.includes(
                                      act.act_id,
                                    ),
                                  )
                                  ?.map((act, i) => {
                                    const isSelected =
                                      selectActivityId.includes(act?.act_id);
                                    return (
                                      <div
                                        key={i}
                                        className="p-2 border rounded"
                                        style={{
                                          backgroundColor: isSelected
                                            ? "#d1e7dd"
                                            : "#f8f9fa",
                                          cursor: "pointer",
                                          flex: "1 1 160px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                        }}
                                        onClick={() => {
                                          if (isSelected) {
                                            setSelectActivityId((prev) =>
                                              prev.filter(
                                                (id) => id !== act?.act_id,
                                              ),
                                            );
                                          } else {
                                            setSelectActivityId((prev) => [
                                              ...prev,
                                              act?.act_id,
                                            ]);
                                          }
                                        }}
                                      >
                                        <span className="text-capitalize">
                                          {act?.name.replace(/_/g, " ")}
                                        </span>
                                        {isSelected && (
                                          <span className="text-success fw-bold ms-2">
                                            ✔
                                          </span>
                                        )}
                                      </div>
                                    );
                                  })}
                              </div>
                              {activityLength === 0 && (
                                <p className="text-muted mt-2">
                                  No activities are currently disabled for this
                                  user.
                                </p>
                              )}
                            </Form.Group>
                          </Form>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            onClick={() => handleDisableModalClose("enable")}
                          >
                            Close
                          </Button>
                          <Button
                            variant="success"
                            onClick={() =>
                              handleActivity(
                                selectedActivity?.username,
                                "enable",
                              )
                            }
                            disabled={selectActivityId.length === 0}
                          >
                            Enable Selected
                          </Button>
                        </Modal.Footer>
                      </Modal>

                      {/* Modal for DISABLING Action Activities */}
                      <Modal
                        show={showDisableModal}
                        onHide={() => handleDisableModalClose("disable")}
                        scrollable
                        backdropClassName="modal-backdrop-light"
                        centered
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Disable User Activity</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <p>
                            Select activities to <u>DISABLE</u> for user:{" "}
                            <strong>{selectedActivity?.username}</strong>.
                          </p>
                          <hr />
                          <Form>
                            <Form.Group controlId="formDisableActivitySelection">
                              <Form.Label>
                                Currently Enabled Activities:
                              </Form.Label>
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "10px",
                                }}
                              >
                                {showDisableModal == true &&
                                  activityData
                                    ?.filter(
                                      (act) =>
                                        act?.allowed_roles?.includes("user") &&
                                        Number(act?.status) === 1 &&
                                        !selectedActivity?.disabled_activities?.includes(
                                          act.act_id,
                                        ),
                                    )
                                    ?.map((act, i) => {
                                      const isSelected =
                                        selectActivityId.includes(act?.act_id);
                                      return (
                                        <div
                                          key={i}
                                          className="p-2 border rounded"
                                          style={{
                                            backgroundColor: isSelected
                                              ? "#f8d7da"
                                              : "#f8f9fa",
                                            cursor: "pointer",
                                            flex: "1 1 160px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                          }}
                                          onClick={() => {
                                            if (isSelected) {
                                              setSelectActivityId((prev) =>
                                                prev.filter(
                                                  (id) => id !== act?.act_id,
                                                ),
                                              );
                                            } else {
                                              setSelectActivityId((prev) => [
                                                ...prev,
                                                act?.act_id,
                                              ]);
                                            }
                                          }}
                                        >
                                          <span className="text-capitalize">
                                            {act?.name.replace(/_/g, " ")}
                                          </span>
                                          {isSelected && (
                                            <span className="text-danger fw-bold ms-2">
                                              ✔
                                            </span>
                                          )}
                                        </div>
                                      );
                                    })}
                              </div>
                            </Form.Group>
                          </Form>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            onClick={() => handleDisableModalClose("disable")}
                          >
                            Close
                          </Button>
                          <Button
                            variant="danger"
                            onClick={() =>
                              handleActivity(
                                selectedActivity?.username,
                                "disable",
                              )
                            }
                            disabled={selectActivityId.length === 0}
                          >
                            Disable Selected
                          </Button>
                        </Modal.Footer>
                      </Modal>

                      {/* Modal for Enabling Tree Activities */}
                      {/* <Modal
                        show={showEnableTreeModal}
                        onHide={() => handleTreeModalClose("enable")}
                        centered
                        scrollable // Added scrollable to match previous modals
                        backdropClassName="modal-backdrop-light"
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Enable Tree Access</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <p>
                            Select tree activities to <u>ENABLE</u> for user:{" "}
                            <strong>{selectedActivity?.username}</strong>.
                          </p>
                          <hr />
                          <Form>
                            <Form.Group controlId="formEnableTreeActivitySelection">
                              <Form.Label>
                                Currently Disabled Tree Activities:
                              </Form.Label>
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "10px",
                                }}
                              >
                                {activityData
                                  ?.filter((act) =>
                                    selectedActivity?.disabled_activities?.includes(
                                      act.act_id
                                    )
                                  )
                                  ?.map((act, i) => {
                                    const isSelected =
                                      selectActivityId.includes(act?.act_id);
                                    return (
                                      <div
                                        key={i}
                                        className="p-2 border rounded"
                                        style={{
                                          backgroundColor: isSelected
                                            ? "#d1e7dd"
                                            : "#f8f9fa",
                                          cursor: "pointer",
                                          flex: "1 1 160px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                        }}
                                        onClick={() => {
                                          if (isSelected) {
                                            setSelectActivityId((prev) =>
                                              prev.filter(
                                                (id) => id !== act?.act_id
                                              )
                                            );
                                          } else {
                                            setSelectActivityId((prev) => [
                                              ...prev,
                                              act?.act_id,
                                            ]);
                                          }
                                        }}
                                      >
                                        <span className="text-capitalize">
                                          {act?.name.replace(/_/g, " ")}
                                        </span>
                                        {isSelected && (
                                          <span className="text-success fw-bold ms-2">
                                            ✔
                                          </span>
                                        )}
                                      </div>
                                    );
                                  })}
                              </div>
                              {activityLength === 0 && (
                                <p className="text-muted mt-2">
                                  No tree activities are currently disabled for
                                  this user.
                                </p>
                              )}
                            </Form.Group>
                          </Form>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            onClick={() => handleTreeModalClose("enable")}
                          >
                            Close
                          </Button>
                          <Button
                            variant="success"
                            onClick={() =>
                              handleActivityTree(
                                selectedActivity?.uid,
                                "enable",
                                selectActivityId
                              )
                            } // Pass selectActivityId
                            disabled={selectActivityId.length === 0}
                          >
                            Enable Selected
                          </Button>
                        </Modal.Footer>
                      </Modal> */}

                      {/* Modal for DISABLING Tree Access */}
                      {/* <Modal
                        show={showDisableTreeModal}
                        onHide={() => handleTreeModalClose("disable")}
                        centered
                        scrollable // Added scrollable to match previous modals
                        backdropClassName="modal-backdrop-light"
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Disable Tree Access</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <p>
                            Select tree activities to <u>DISABLE</u> for user:{" "}
                            <strong>{selectedActivity?.username}</strong>.
                          </p>
                          <hr />
                          <Form>
                            <Form.Group controlId="formDisableTreeActivitySelection">
                              <Form.Label>
                                Currently Enabled Tree Activities:
                              </Form.Label>
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "10px",
                                }}
                              >
                                {activityData
                                  ?.filter(
                                    (act) =>
                                      act?.allowed_roles?.includes("user") && // Assuming tree activities also have this role
                                      Number(act?.status) === 1 &&
                                      !selectedActivity?.disabled_activities?.includes(
                                        act.act_id
                                      )
                                  )
                                  ?.map((act, i) => {
                                    const isSelected =
                                      selectActivityId.includes(act?.act_id);
                                    return (
                                      <div
                                        key={i}
                                        className="p-2 border rounded"
                                        style={{
                                          backgroundColor: isSelected
                                            ? "#f8d7da"
                                            : "#f8f9fa",
                                          cursor: "pointer",
                                          flex: "1 1 160px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                        }}
                                        onClick={() => {
                                          if (isSelected) {
                                            setSelectActivityId((prev) =>
                                              prev.filter(
                                                (id) => id !== act?.act_id
                                              )
                                            );
                                          } else {
                                            setSelectActivityId((prev) => [
                                              ...prev,
                                              act?.act_id,
                                            ]);
                                          }
                                        }}
                                      >
                                        <span className="text-capitalize">
                                          {act?.name.replace(/_/g, " ")}
                                        </span>
                                        {isSelected && (
                                          <span className="text-danger fw-bold ms-2">
                                            ✔
                                          </span>
                                        )}
                                      </div>
                                    );
                                  })}
                              </div>
                              {activityData?.filter(
                                (act) =>
                                  act?.allowed_roles?.includes("user") &&
                                  Number(act?.status) === 1 &&
                                  !selectedActivity?.disabled_activities?.includes(
                                    act.act_id
                                  )
                              )?.length === 0 && (
                                <p className="text-muted mt-2">
                                  No tree activities are currently enabled for
                                  this user.
                                </p>
                              )}
                            </Form.Group>
                          </Form>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            onClick={() => handleTreeModalClose("disable")}
                          >
                            Close
                          </Button>
                          <Button
                            variant="danger"
                            onClick={() =>
                              handleActivityTree(
                                selectedActivity?.uid,
                                "disable",
                                selectActivityId
                              )
                            } // Pass selectActivityId
                            disabled={selectActivityId.length === 0}
                          >
                            Disable Selected
                          </Button>
                        </Modal.Footer>
                      </Modal> */}

                      {/* {permissions?.setTreeActivities && (
                        <td className="text-center">
                          <button
                            className="btn btn-success"
                            style={{
                              marginRight: "10px",
                            }}
                            onClick={() => handleTreeModalShow(x, "enable")}
                          >
                            Enable
                          </button>
                          <button
                            className="btn btn-danger"
                            onClick={() => handleTreeModalShow(x, "disable")}
                          >
                            Disable
                          </button>
                        </td>
                      )} */}

                      {/* <td style={{ textAlign: "center" }}>
                        {" "}
                        {x?.widthrawal_tree_block === 0 ? (
                          <button
                            className="btn btn-danger block-btn"
                            onClick={() => handleTreeModalShow(x?.uid, 0)}
                          >
                            Disable
                          </button>
                        ) : (
                          <button
                            className="btn btn-success block-btn"
                            onClick={() => handleTreeModalShow(x?.uid, 1)}
                          >
                            Enable
                          </button>
                        )}
                      </td> */}
                      {permissions?.setUserPasswordUpdate &&
                        permissions?.setUserProfileUpdate && (
                          <td>
                            <button
                              className="block-btn"
                              onClick={() =>
                                navigate("/dashboard/edit-profile", {
                                  state: {
                                    user: x,
                                    fromAllUsers: {
                                      currentPage,
                                      limitFilter,
                                      search,
                                      dateFilter,
                                    },
                                  },
                                })
                              }
                            >
                              Edit Profile
                            </button>
                          </td>
                        )}
                      {permissions?.setBlockUnblockUser && (
                        <td>
                          {x?.blockStatus === 0 ? (
                            <button
                              className="btn btn-danger block-btn"
                              onClick={() => handleModalShow(x?.username, 1)}
                            >
                              Block
                            </button>
                          ) : (
                            <button
                              className="btn btn-success block-btn"
                              onClick={() => handleModalShow(x?.username, 0)}
                            >
                              Unblock
                            </button>
                          )}
                        </td>
                      )}
                    </tr>
                  );
                })}
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
        </section>
        <Modal show={showModal} onHide={handleModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Action</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to {blockStatus === 1 ? "block" : "unblock"}{" "}
            this user?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleModalClose}>
              Cancel
            </Button>
            <Button
              variant={blockStatus === 1 ? "danger" : "success"}
              onClick={() => {
                BlockUsers(selectedUser, blockStatus);
                handleModalClose();
              }}
            >
              {blockStatus === 1 ? "Block" : "Unblock"}
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={showTreeModal} onHide={handleTreeModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Action</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to {treeStatus === 1 ? "enable" : "disable"}{" "}
            this user tree withdrawal?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleTreeModalClose}>
              Cancel
            </Button>
            <Button
              variant={treeStatus === 1 ? "success" : "danger"}
              onClick={() => {
                BlockUserTree(selectedUid, treeStatus);
                handleTreeModalClose();
              }}
            >
              {treeStatus === 1 ? "Enable" : "Disable"}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={sponsorShow} onHide={handleSponsorModalClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>Change sponsor</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="mb-2">
              <strong>User:</strong> {sponsorRowUsername}
            </p>
            <p className="mb-3">
              <strong>Current sponsor:</strong>{" "}
              {sponsorUsername || <span className="text-muted">—</span>}
            </p>
            <Form.Group className="mb-2">
              <Form.Label>New sponsor username</Form.Label>
              <Form.Control
                type="text"
                value={newSponsor}
                onChange={(e) => setNewSponsor(e.target.value)}
                placeholder="Enter sponsor username"
                autoComplete="off"
              />
            </Form.Group>
            <p className="mb-3 small text-muted">
              {sponsorCheckLoading
                ? "Checking…"
                : `Sponsor name: ${existUserName}`}
            </p>
            <Form.Group className="mb-0">
              <Form.Label>Position</Form.Label>
              <div className="d-flex gap-3">
                <Form.Check
                  type="radio"
                  id="sponsor-position-left"
                  name="sponsorPosition"
                  label="Left"
                  value="left"
                  checked={sponsorPosition === "left"}
                  onChange={() => setSponsorPosition("left")}
                />
                <Form.Check
                  type="radio"
                  id="sponsor-position-right"
                  name="sponsorPosition"
                  label="Right"
                  value="right"
                  checked={sponsorPosition === "right"}
                  onChange={() => setSponsorPosition("right")}
                />
              </div>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleSponsorModalClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSponsorChange}>
              Update sponsor
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={openSponsorSuccessDialog}
          onHide={handleSponsorDialogClose}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Success</Modal.Title>
          </Modal.Header>
          <Modal.Body>Sponsor has been updated successfully.</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleSponsorDialogClose}>
              OK
            </Button>
          </Modal.Footer>
        </Modal>

        <Row className="users-pagination">
          <Col md="12">
            {
              <PaginationComponent
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePagination}
              />
            }
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default AllUsers;
